import React from "react";
import { Button } from "@/components/ui/button";
import { DownloadSimple } from "@phosphor-icons/react";
import { designImg, designDxf } from "./designsApi";

export const LensResultCard = ({ r, onOpen }) => (
  <div className={"rounded-sm border overflow-hidden bg-slate-900/60 " + (r.is_match ? "border-emerald-500/60" : "border-slate-800")}
    data-testid={`lens-result-${r.serial_label || r.id}`}>
    <div className="px-3 py-2 flex items-center justify-between gap-2">
      <span className="font-mono-num text-xl font-black text-orange-400 whitespace-nowrap shrink-0">{r.serial_label || "D-…"}</span>
      <span className={"font-mono-num text-xs sm:text-sm font-bold px-2 py-0.5 rounded-sm text-right " + (r.is_match ? "bg-emerald-500/15 text-emerald-300" : "bg-slate-800 text-slate-400")}
        data-testid="lens-result-pct">
        {r.match_pct}% {r.is_match ? "MATCH" : "kam match"}
      </span>
    </div>
    {r.superseded && <div className="px-3 pb-1 text-[10px] text-amber-300">PURANA VERSION</div>}
    <button type="button" onClick={() => onOpen(r)} className="w-full aspect-square bg-slate-200 flex items-center justify-center">
      <img src={designImg(r.id, true, r.rendered_at)} alt={r.serial_label} className="max-w-full max-h-full object-contain" />
    </button>
    <div className="p-3 space-y-0.5 text-sm">
      <div className="font-mono-num text-slate-200">#{r.order_number}</div>
      <div className="text-slate-100 truncate">{r.customer_name}</div>
      <div className="text-xs text-slate-400 font-mono-num">{r.plate_size}</div>
      <Button asChild size="sm" className="w-full mt-2 rounded-sm bg-orange-500 hover:bg-orange-600 text-white" data-testid="lens-result-download">
        <a href={designDxf(r.id)} download={r.original_filename || `${r.order_number}.dxf`}>
          <DownloadSimple size={14} className="mr-1" /> DOWNLOAD DXF
        </a>
      </Button>
    </div>
  </div>
);
